import React, {Component} from 'react';
import { Popover } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';

import { PATH1, PATH2, PATH3, PATH4, PATH5 } from '../resources/modernization-paths';

class AssetModernizationPathsPopover extends Component {

    getPaths(data) {
        let paths = [];

        for (let assetName in data) {
            const pathId = data[assetName].supportedPath;
            const assetType = data[assetName].assetType;

            let pathName;

            switch(pathId) {
                case 1:
                    pathName = PATH1;
                    break;
                case 2:
                    pathName = PATH2;
                    break;
                case 3:
                    pathName = PATH3;
                    break;
                case 4:
                    pathName = PATH4;
                    break;
                case 5:
                    pathName = PATH5;
                    break;
            }

            paths.push({
                "asset": assetName,
                "assetType": assetType,
                "path": pathName
            });
        }

        return paths;
    }

    getAssetsFromData(data) {
        const assets = JSON.parse(JSON.stringify(this.props.data));

        delete assets.archive;
        delete assets.engine;
        delete assets.project;
        delete assets.supportedPath;
        delete assets.assetCount;

        return assets
    }

    render() {
        const assets = this.getAssetsFromData(this.props.data);
        const paths = this.getPaths(assets);

        const headerStyle = {
            backgroundColor: '#f0f0f0'
        };

        const columns = [
            {
                dataField: 'asset',
                text: 'Asset',
                headerStyle: headerStyle,
                sort: true
            },
            {
                dataField: 'assetType',
                text: 'Asset Type',
                headerStyle: headerStyle,
                sort: true
            },
            {
                dataField: 'path',
                text: 'Modernization Path',
                headerStyle: headerStyle,
                sort: true
            }
        ];

        return (
          <Popover id="popover-basic" title="Asset Modernization Paths">
              <div>
                <h3>{this.props.data.project}</h3>
              </div>
              <BootstrapTable
                    keyField='job'
                    data={ paths }
                    columns={ columns }
                    defaultSorted={[
                        {
                            dataField: 'path',
                            order: 'asc'
                        }
                    ]}
              />
          </Popover>
        );
    }
};

export default AssetModernizationPathsPopover;
